import {Pipe, PipeTransform} from '@angular/core';
import {DatePipe} from '@angular/common';

@Pipe({
  name: 'utcDateFormat'
})
export class UtcDateFormatPipe extends DatePipe implements PipeTransform {
  transform(value: any, format?: string, args?: any): any {
    if (!value) {
      return '';
    }
    if (!format) {
      return super.transform(value, 'yyyy-MM-dd HH:mm:ss', '+000');
    } else {
      return super.transform(value, format, '+000');
    }
  }
}
